module.exports = __webpack_public_path__ + "img/shades_thumb.f73e0759.jpg";